import type { Locale } from '../types'

export const strings: Record<Locale, Record<string, string>> = {
  'pt-BR': {
    'nav.home': 'Home',
    'nav.explore': 'Explore',
    'nav.new': 'Novo',
    'nav.stats': 'Stats',
    'nav.check': 'Check',
    'nav.profile': 'Perfil',
    'nav.aria': 'Navegação principal',

    'common.xp': 'XP',
    'common.of': 'de',
    'common.day': 'dia',
    'common.days': 'dias',
    'common.back': 'Voltar',
    'common.close': 'Fechar',
    'common.continue': 'Continuar',
    'common.notifications': 'Notificações',
    'common.level': 'Nível',

    'band.strong': 'Faixa forte',
    'band.attention': 'Faixa de atenção',
    'band.low': 'Faixa baixa',

    'home.greeting.morning': 'Bom dia',
    'home.greeting.afternoon': 'Boa tarde',
    'home.greeting.evening': 'Boa noite',
    'home.lifescore.title': 'Life Score de hoje',
    'home.lifescore.hint': 'Seu bem-estar de hoje em uma escala de 0 a 100.',
    'home.message.first': 'Seu primeiro dia começa agora.',
    'home.message.complete': 'Dia fechado com {total} XP registrados.',
    'home.message.rest': 'Hoje o objetivo é recuperar.',
    'home.message.past50': 'Você já chegou à metade da sua meta de hoje.',
    'home.message.going': 'Faltam {n} XP para fechar o dia.',
    'home.message.start': 'Seu dia ainda não começou a contar.',
    'home.pending.title': 'Ainda falta hoje',
    'home.pending.hint': 'Toque para abrir no Daily Check.',
    'home.streak.title': 'Sequência',
    'home.streak.best': 'Sem falhas desde 9 de setembro',
    'home.xp.title': 'XP hoje',
    'home.xp.base': 'de 100 XP base',
    'home.check.title': 'Daily Check',
    'home.check.progress': '{done} de {total} hábitos concluídos',
    'home.check.remaining': '{n} XP restantes',
    'home.check.allDone': 'Nenhum hábito pendente',
    'home.milestone.title': 'Próximo marco',
    'home.milestone.max': 'Todos os marcos conquistados',
    'home.check.cta': 'Continuar Daily Check',
    'home.check.ctaStart': 'Começar Daily Check',
    'home.check.ctaDone': 'Ver meu Daily Check',
    'home.week.title': 'Progresso da semana',
    'home.week.avg': 'Média {n}',
    'home.community.title': 'Comunidade',
    'home.community.cta': 'Ver tudo',
    'home.summary.title': 'Seu dia',
    'home.summary.lifescore': 'Life Score',
    'home.summary.check': 'Daily Check',
    'home.summary.streak': 'Sequência',
    'home.summary.milestone': 'Próximo marco',
    'home.summary.open': 'Abrir Life Score em detalhe',
    'home.pulse.own': 'Seu Pulse',
    'home.foryou.title': 'Para você',
    'home.foryou.cta': 'Ver o feed',
    'home.firstUse.title': 'Comece pelo seu dia.',
    'home.firstUse.body':
      'Seis hábitos, 100 XP. É assim que o seu Life Score nasce.',
    'home.firstUse.cta': 'Fazer meu primeiro check',
    'home.gentle.title': 'Metas gentis para hoje',
    'home.gentle.body': 'Descansar também é evoluir.',
    'home.gentle.1': 'Avance na sua meta de hidratação de hoje.',
    'home.gentle.2': '10 min de caminhada ou alongamento',
    'home.gentle.3': '5 min de respiração',
    'home.gentle.4': 'Priorizar dormir mais cedo',

    'check.title': 'Daily Check',
    'check.subtitle': 'Seis hábitos. 100 XP no dia.',
    'check.earned': 'XP conquistado',
    'check.remaining': 'XP restante',
    'check.completed': 'Concluídos',
    'check.left': 'Restantes',
    'check.mood.title': 'Como você está hoje?',
    'check.mood.registered': 'Humor registrado',
    'check.bonus.title': 'Foto do dia',
    'check.bonus.body':
      'Bônus opcional de +10 XP, separado dos 100 XP do Daily Check.',
    'check.bonus.cta': 'Adicionar foto',
    'check.bonus.done': 'Bônus de +10 XP recebido',
    'check.complete.title': 'Dia completo',
    'check.complete.body':
      '100 XP registrados. Sua sequência chegou a {n} dias.',
    'check.badge.title': 'Nova medalha',
    'check.badge.body': '{days} dias de Daily Check concluído.',
    'check.unlocked': 'Post completo liberado',

    'feedback.first': 'O começo é tudo.',
    'feedback.half': 'Metade feita.',
    'feedback.fifty': 'Hoje já valeu a pena.',
    'feedback.seventyfive': 'Quase lá.',
    'feedback.one': 'Falta só 1.',

    'habit.hydration.title': 'Hidratação',
    'habit.movement.title': 'Movimento',
    'habit.movement.goal': 'Ao menos 30 min de atividade',
    'habit.mind.title': 'Mente',
    'habit.mind.goal': '10 min de clareza mental',
    'habit.nutrition.title': 'Nutrição',
    'habit.nutrition.goal': 'Alimentação e suplementos do dia',
    'habit.sleep.title': 'Sono',
    'habit.sleep.goal': '7h ou mais de descanso',
    'habit.mood.title': 'Humor',
    'habit.mood.goal': 'Registre como você está',

    'mood.drained': 'Esgotado',
    'mood.tired': 'Cansado',
    'mood.neutral': 'Neutro',
    'mood.good': 'Bem',
    'mood.focused': 'Focado',

    'level.1': 'Iniciante',
    'level.2': 'Aprendiz',
    'level.3': 'Guerreiro',
    'level.4': 'Mestre',
    'level.5': 'Lenda',

    'badge.first': 'Primeiro Check',
    'badge.focus': 'Foco Total',
    'badge.week': 'Semana de Ferro',
    'badge.unstoppable': 'Imparável',
    'badge.legend': 'Lenda Viva',

    'stats.title': 'Estatísticas',
    'stats.subtitle': 'Sua consistência ao longo do tempo.',
    'stats.period.today': 'Hoje',
    'stats.period.week': 'Semana',
    'stats.period.month': 'Mês',
    'stats.period.year': 'Ano',
    'stats.lifescore.today': 'Life Score de hoje',
    'stats.lifescore.week': 'Média dos últimos 7 dias',
    'stats.lifescore.month': 'Média dos últimos 30 dias',
    'stats.lifescore.year': 'Média de todo o histórico registrado',
    'stats.streak': 'Sequência atual',
    'stats.avg30': 'Média 30 dias',
    'stats.perfect': 'Dias perfeitos',
    'stats.workouts': 'Treinos na semana',
    'stats.heatmap.title': 'Consistência · 90 dias',
    'stats.heatmap.hint': 'Semanas em colunas, começando na segunda.',
    'stats.heatmap.none': 'Sem registro',
    'stats.heatmap.low': 'Baixa',
    'stats.heatmap.high': 'Alta',
    'stats.heatmap.perfect': 'Dia perfeito',
    'stats.heatmap.cell': '{date}: Life Score {score}',
    'stats.heatmap.cellEmpty': '{date}: sem registro',
    'stats.review.title': 'Revisão semanal',
    'stats.review.locked': 'Disponível domingo, a partir das 18h.',
    'stats.review.strong': 'Mais forte',
    'stats.review.weak': 'Precisa de atenção',
    'stats.review.avg': 'Média da semana',
    'stats.review.tip': 'Uma melhoria prática',
    'stats.review.tipBody':
      'Antecipe o sono em 30 min nas noites anteriores aos treinos.',
    'stats.insights.title': 'Insights de humor',
    'stats.insights.hint': 'Correlações observadas nos seus registros.',
    'stats.goals.title': 'Metas',
    'stats.discipline.title': 'Disciplina Construída',
    'stats.discipline.body':
      '{n} dias consecutivos com Life Score 70 ou mais. Consistência > Motivação.',
    'stats.category.movement': 'Movimento',
    'stats.category.sleep': 'Sono',

    'create.title': 'Publicar',
    'create.subtitle': 'Escolha o formato do seu registro.',
    'create.pulse.title': 'Pulse',
    'create.pulse.body': 'Registro rápido do seu momento. Sempre disponível.',
    'create.post.title': 'Post',
    'create.post.body': 'Publicação completa com o contexto da sua jornada.',
    'create.post.locked': 'Requer {gate} XP hoje',
    'create.post.unlocked': 'Liberado hoje',
    'create.gate.progress': '{xp} de {gate} XP hoje',
    'create.gate.cta': 'Ir para o Daily Check',

    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',

    'settings.title': 'Configurações',
    'settings.group.account': 'Conta',
    'settings.group.experience': 'Experiência',
    'settings.group.privacy': 'Privacidade e segurança',
    'settings.group.support': 'Suporte e documentos',
    'settings.account': 'Conta',
    'settings.language': 'Idioma',
    'settings.units': 'Unidades',
    'settings.notifications': 'Notificações',
    'settings.privacy': 'Privacidade',
    'settings.security': 'Segurança',
    'settings.accessibility': 'Acessibilidade',
    'settings.services': 'Serviços conectados',
    'settings.help': 'Ajuda e suporte',
    'settings.terms': 'Termos de uso',
    'settings.policy': 'Política de privacidade',
    'settings.logout': 'Sair da conta',
    'settings.delete': 'Excluir conta',
    'settings.deleteHint': 'Ação permanente, com confirmação em etapas.',
    'settings.logout.title': 'Sair da conta?',
    'settings.logout.body':
      'Seus dados continuam salvos. Você pode entrar novamente quando quiser.',
    'settings.logout.confirm': 'Sair agora',

    'account.statusActive': 'Conta ativa',
    'account.data': 'Dados da conta',
    'account.email': 'E-mail',
    'account.birth': 'Data de nascimento',
    'account.management': 'Gestão da conta',
    'account.export': 'Baixar meus dados',
    'account.exportHint': 'Arquivo com hábitos, métricas e publicações.',

    'language.subtitle': 'A escolha vale para todo o produto.',
    'language.note':
      'Não existem telas separadas por idioma: todo texto vem do mesmo dicionário.',

    'units.subtitle': 'Uma preferência única para todo o app.',
    'units.metric': 'Métrico',
    'units.imperial': 'Imperial',
    'units.affects': 'O que muda',
    'units.affects.body': 'Peso, altura e composição corporal',
    'units.affects.sports': 'Distâncias, pace, splits e cargas',
    'units.affects.charts': 'Eixos e legendas dos gráficos',

    'notifPrefs.subtitle': 'Escolha o que merece interromper o seu dia.',
    'notifPrefs.priority':
      'Lembretes de saúde têm prioridade sobre qualquer aviso social.',
    'notifPrefs.group.health': 'Saúde e bem-estar',
    'notifPrefs.group.progress': 'Progresso',
    'notifPrefs.group.social': 'Social',
    'notifPrefs.group.product': 'Produto',
    'notifPrefs.healthNote': 'Recomendamos manter este grupo ativo.',

    'notifications.today': 'Hoje',
    'notifications.earlier': 'Antes',
    'notifications.markAll': 'Marcar todas como lidas',
    'notifications.unreadCount': '{n} não lidas',

    'privacy.subtitle': 'Você decide o que é público.',
    'privacy.visibility': 'Visibilidade do perfil',
    'privacy.health': 'Dados de saúde',
    'privacy.healthNote':
      'Métricas corporais e biomarcadores são privados por padrão. Nenhuma métrica é publicada sem o seu consentimento explícito, uma a uma.',
    'privacy.pickMetrics': 'Escolha métrica por métrica.',
    'privacy.dataUse': 'Como usamos seus dados',
    'privacy.use1': 'Seus registros geram o Life Score, as estatísticas e os insights.',
    'privacy.use2': 'Métricas corporais e biomarcadores ficam visíveis só para você, a menos que você escolha torná-los públicos.',
    'privacy.use3': 'Você pode baixar ou excluir seus dados a qualquer momento.',
    'privacy.consent': 'Histórico de consentimentos',
    'privacy.consentTitle': 'Tornar dados de saúde públicos?',
    'privacy.consentBody':
      'Isso publica dados de composição corporal no seu perfil. Você pode desativar depois, a qualquer momento.',
    'privacy.consentAccept': 'Sim, eu autorizo',
    'privacy.consentKeep': 'Manter privado',

    'security.subtitle': 'Acesso, dispositivos e atividade.',
    'security.access': 'Acesso',
    'security.password': 'Alterar senha',
    'security.passwordHint': 'Última alteração há 4 meses.',
    'security.twoFactor': 'Autenticação em duas etapas',
    'security.twoFactorHint': 'Código adicional ao entrar em um novo dispositivo.',
    'security.recovery': 'Recuperação de conta',
    'security.recoveryHint': 'E-mail e telefone de recuperação.',
    'security.devices': 'Dispositivos',
    'security.sessions': 'Sessões ativas',
    'security.trusted': 'Dispositivos confiáveis',
    'security.trustedHint': 'Não pedem código em duas etapas.',
    'security.activity': 'Atividade de login',

    'sessions.subtitle': 'Onde a sua conta está conectada.',
    'sessions.active': 'Ativas agora',
    'sessions.thisDevice': 'Este dispositivo',
    'sessions.trusted': 'Confiável',
    'sessions.signOut': 'Encerrar',
    'sessions.signOutOthers': 'Encerrar os outros dispositivos',
    'sessions.note': 'Encerrar uma sessão não apaga nenhum dado.',

    'a11y.subtitle': 'Ajustes que valem para todo o app.',
    'a11y.reader': 'Leitores de tela',
    'a11y.readerBody':
      'O BEELYV é construído com HTML semântico e rótulos descritivos, sem tema visual separado.',
    'a11y.point1': 'Todo botão e alternância tem rótulo e estado anunciáveis.',
    'a11y.point2': 'Gráficos e o heatmap expõem os valores em texto.',
    'a11y.point3': 'Áreas de toque têm no mínimo 44px.',
    'a11y.note':
      'Estas preferências adaptam o design system existente. Nenhum tema alternativo é criado.',

    'services.subtitle': 'Integrações de saúde e performance.',
    'services.note':
      'Nenhuma integração está ativa. Estas conexões estão em preparação.',
    'services.comingSoon': 'Em breve',
    'services.futureNote':
      'Quando uma conexão ficar disponível, você autoriza o acesso antes de qualquer sincronização.',

    'help.subtitle': 'Dúvidas, contato e informações do app.',
    'help.faq': 'Perguntas frequentes',
    'help.contactGroup': 'Contato',
    'help.contact': 'Falar com o suporte',
    'help.report': 'Relatar um problema',
    'help.reportHint': 'Erros, conteúdo impróprio ou comportamento inesperado.',
    'help.guidelines': 'Diretrizes da comunidade',
    'help.safety': 'Informações de segurança',
    'help.about': 'Sobre o BEELYV',
    'help.version': 'Versão',
    'help.aboutBody':
      'Um ecossistema de saúde, mente, hábitos, performance e comunidade. Autocuidado primeiro, social depois.',
    'help.states': 'Estados do app',
    'help.statesHint': 'Referência de carregamento, vazio, offline e permissões.',

    'export.subtitle': 'Uma cópia dos seus dados, quando quiser.',
    'export.included': 'O que vai no arquivo',
    'export.item1': 'Histórico completo do Daily Check e do Life Score',
    'export.item2': 'Métricas corporais e esportivas',
    'export.item3': 'Posts, Pulses e comentários',
    'export.item4': 'Preferências de conta e consentimentos',
    'export.request': 'Solicitar meus dados',
    'export.again': 'Solicitar novamente',
    'export.preparing': 'Preparando o seu arquivo…',
    'export.ready': 'Arquivo pronto para download',
    'export.readyBody': 'O link também é enviado para o seu e-mail cadastrado.',
    'export.note': 'O arquivo é gerado sob demanda e não é compartilhado com terceiros.',

    'delete.whatHappens': 'O que acontece',
    'delete.p1': 'Seu perfil, posts e Pulses saem do ar.',
    'delete.p2': 'Histórico de hábitos, métricas e medalhas são apagados.',
    'delete.p3': 'A ação é permanente e não pode ser desfeita.',
    'delete.p4': 'Você pode baixar seus dados antes de continuar.',
    'delete.alternative': 'Prefere guardar uma cópia antes de decidir?',
    'delete.continue': 'Continuar',
    'delete.confirmTitle': 'Confirmação',
    'delete.confirmBody':
      'Queremos ter certeza de que essa é a sua intenção. Nada é excluído nesta etapa.',
    'delete.checkbox':
      'Entendi que meus dados de saúde e meu histórico serão apagados de forma permanente.',
    'delete.passwordTitle': 'Confirme com a sua senha',
    'delete.passwordBody': 'Isso evita exclusões acidentais ou por outra pessoa.',
    'delete.passwordHint': 'Sua senha',
    'delete.finalTitle': 'Último aviso',
    'delete.finalBody':
      'Ao confirmar, a exclusão começa imediatamente e não há como recuperar os dados.',
    'delete.finalCta': 'Excluir minha conta',
    'delete.keepAccount': 'Manter minha conta',
    'delete.doneTag': 'Conta excluída',
    'delete.doneTitle': 'Tudo certo.',
    'delete.doneBody':
      'Sua conta e seus dados foram removidos. Obrigado por ter cuidado do seu dia com o BEELYV.',
    'delete.doneCta': 'Voltar ao início',

    'states.title': 'Estados do app',
    'states.subtitle': 'Referência dos estados globais reutilizáveis.',
    'states.group.loading': 'Carregamento',
    'states.group.content': 'Conteúdo',
    'states.group.system': 'Sistema',
    'states.group.access': 'Acesso e permissões',
    'states.group.feedback': 'Confirmação',

    'state.retry': 'Tentar novamente',
    'state.backHome': 'Voltar para a Home',
    'state.permission.cta': 'Abrir Ajustes',
    'state.permission.skip': 'Continuar sem permitir',

    'state.loading.tag': 'Carregando',
    'state.loading.title': 'Carregando',
    'state.loading.body': 'Buscando os seus dados mais recentes.',
    'state.skeleton.tag': 'Esqueleto',
    'state.skeleton.title': 'Carregamento estruturado',
    'state.skeleton.body': 'O layout aparece antes do conteúdo, sem saltos.',
    'state.empty.tag': 'Vazio',
    'state.empty.title': 'Nada por aqui ainda',
    'state.empty.body': 'Quando houver conteúdo, ele aparece nesta área.',
    'state.success.tag': 'Concluído',
    'state.success.title': 'Tudo certo.',
    'state.success.body': 'Sua ação foi registrada com sucesso.',
    'state.offline.tag': 'Sem conexão',
    'state.offline.title': 'Você está offline.',
    'state.offline.body':
      'Sem problema: o essencial continua funcionando e sincroniza quando a conexão voltar.',
    'state.offline.p1': 'Marcar hábitos no Daily Check',
    'state.offline.p2': 'Ver o Life Score e as estatísticas já carregadas',
    'state.offline.p3': 'Rascunhos de Pulse e Post ficam salvos',
    'state.error.tag': 'Algo não carregou',
    'state.error.title': 'Não conseguimos carregar esta tela.',
    'state.error.body':
      'Seus dados estão seguros. Tente novamente em alguns instantes.',
    'state.locked.tag': 'Bloqueado',
    'state.locked.title': 'Post completo ainda bloqueado.',
    'state.locked.body':
      'Ele abre com 50 XP no dia. O Pulse continua disponível a qualquer momento.',
    'state.session.tag': 'Sessão expirada',
    'state.session.title': 'Sua sessão expirou.',
    'state.session.body':
      'Por segurança, encerramos o acesso após um período inativo. Nenhum dado foi perdido.',
    'state.session.cta': 'Entrar novamente',
    'state.maintenance.tag': 'Manutenção',
    'state.maintenance.title': 'Estamos em manutenção.',
    'state.maintenance.body':
      'Uma melhoria está sendo aplicada. Voltamos em alguns minutos.',
    'state.update.tag': 'Atualização disponível',
    'state.update.title': 'Uma nova versão está pronta.',
    'state.update.body': 'A atualização traz correções e melhorias de desempenho.',
    'state.update.cta': 'Atualizar agora',
    'state.update.later': 'Depois',
    'state.camera.tag': 'Câmera bloqueada',
    'state.camera.title': 'A câmera está sem permissão.',
    'state.camera.body':
      'A câmera é usada para registrar a Foto do Dia e criar Pulses. Você decide se quer liberar.',
    'state.notifications.tag': 'Notificações bloqueadas',
    'state.notifications.title': 'As notificações estão desativadas.',
    'state.notifications.body':
      'Sem elas, você não recebe o lembrete do Daily Check nem o aviso de sequência.',
    'state.location.tag': 'Localização bloqueada',
    'state.location.title': 'A localização está sem permissão.',
    'state.location.body':
      'Usamos a localização apenas para marcar o local de um post, quando você quiser.',
    'state.photos.tag': 'Fotos bloqueadas',
    'state.photos.title': 'A galeria está sem permissão.',
    'state.photos.body':
      'O acesso à galeria serve para escolher imagens já salvas no seu aparelho.',
    'state.no-results.tag': 'Sem resultados',
    'state.no-results.title': 'Nenhum resultado encontrado.',
    'state.no-results.body': 'Tente outro termo, esporte ou hashtag.',
    'state.no-notifications.tag': 'Sem notificações',
    'state.no-notifications.title': 'Nenhuma notificação por aqui.',
    'state.no-notifications.body':
      'Avisos de saúde e da comunidade aparecem nesta tela.',
    'state.no-posts.tag': 'Sem posts',
    'state.no-posts.title': 'Você ainda não publicou nada.',
    'state.no-posts.body':
      'O Pulse está sempre disponível. O Post completo abre com 50 XP no dia.',
    'state.no-metrics.tag': 'Sem métricas',
    'state.no-metrics.title': 'Nenhuma métrica registrada.',
    'state.no-metrics.body':
      'Adicione peso, altura e composição corporal para ver a sua evolução.',
    'state.first-use.tag': 'Primeiro uso',
    'state.first-use.title': 'Comece pelo seu dia.',
    'state.first-use.body': 'Seis hábitos, 100 XP. É assim que o seu Life Score nasce.',

    'stats.consistency': 'Consistência do Check',
    'stats.consistencyHint': 'Dias com registro nos últimos 90.',
    'stats.details': 'Análises detalhadas',
    'stats.openFull': 'Ver completo',
    'stats.lifescore.open': 'Ver Life Score em detalhe',
    'stats.heatmap.question': 'Onde estão as falhas nos últimos 90 dias?',
    'stats.weekly.title': 'Atividade da semana',
    'stats.weekly.question': 'A semana está no ritmo que você definiu?',
    'stats.weekly.strongDays': 'Dias com 70+',
    'stats.weekly.average': 'Média da semana',

    'lifescore.title': 'Life Score',
    'lifescore.subtitle': 'Seu bem-estar de hoje em uma escala de 0 a 100.',
    'lifescore.best': 'Melhor Life Score',
    'lifescore.bestHint': 'Maior valor do período.',
    'lifescore.strongDays': 'Dias na faixa forte',
    'lifescore.strongHint': 'Life Score 70 ou mais.',
    'lifescore.missed': 'Dias sem registro',
    'lifescore.missedHint': 'Nenhum hábito marcado.',
    'lifescore.bands': 'Faixas',
    'lifescore.note':
      'A pontuação vem apenas dos seus 100 XP de base. O bônus da Foto do Dia não entra no cálculo.',

    'heatmap.consistency': 'Consistência',
    'heatmap.consistencyHint': 'Dias com registro em 90.',
    'heatmap.recorded': 'Dias registrados',
    'heatmap.recordedHint': 'Ao menos um hábito marcado.',
    'heatmap.note':
      'Semanas em colunas, de segunda a domingo. O dourado marca dias perfeitos.',

    'review.subtitle': 'Uma leitura por semana, sem ruído.',
    'review.lockedHint':
      'A revisão fecha a semana inteira, por isso só abre no domingo à noite.',
    'review.avgHint': 'Média dos últimos 7 dias de Daily Check.',
    'review.strongHint': 'Categoria mais concluída na semana.',
    'review.weakHint': 'Categoria com mais falhas na semana.',
    'review.tipNote':
      'Sugestão baseada nos seus registros. Não é orientação médica.',

    'insights.todayMood': 'Humor registrado hoje',
    'insights.noMood': 'Ainda não registrado',
    'insights.disclaimer':
      'Correlações observadas nos seus próprios registros. Não são diagnóstico nem conclusão médica.',

    'goals.subtitle': 'Metas de saúde e performance definidas por você.',
    'goals.of': 'de',
    'goals.note':
      'As metas são suas. O app acompanha o progresso e não recomenda valores de saúde.',

    'metrics.milestones': 'Marcos de força',

    'chart.range.all': 'Tudo',
    'chart.range.3m': '3M',
    'chart.range.6m': '6M',
    'chart.range.1y': '1A',
    'chart.range.2y': '2A',

    'profile.edit': 'Editar perfil',
    'profile.photo': 'Foto de perfil',
    'profile.photoHint': 'No protótipo, a foto permanece a mesma.',
    'profile.identity': 'Identidade',
    'profile.field.name': 'Nome de exibição',
    'profile.field.username': 'Nome de usuário',
    'profile.field.bio': 'Bio',
    'profile.metricsSection': 'Saúde e performance',

    'metrics.units': 'Unidades',
    'metrics.units.metric': 'kg · km',
    'metrics.units.imperial': 'lbs · mi',
    'metrics.values': 'Valores',
    'metrics.visible': 'Visível',
    'metrics.hidden': 'Métricas ocultas',
    'metrics.restore': 'Restaurar todas',
    'metrics.noRecord': 'Sem registro ainda',
    'metrics.openChart': 'abrir gráfico',
    'metrics.editBody': 'Editar métricas corporais',
    'metrics.editHint': 'O IMC é calculado e não pode ser editado.',
    'metrics.body.title': 'Métricas corporais',
    'metrics.body.subtitle': 'Composição corporal e referências de BIA.',
    'metrics.sports.title': 'Métricas esportivas',
    'metrics.sports.subtitle': 'Performance por esporte, com unidades convertíveis.',
    'metrics.sports.note':
      'Toque em uma métrica com gráfico para ver a evolução no período.',
    'metrics.public.title': 'Métricas públicas',
    'metrics.public.subtitle': 'Escolha o que aparece no seu perfil público.',
    'metrics.public.note':
      'Métricas corporais, BIA e biomarcadores são privados por padrão. Só aparecem no perfil público se você der consentimento explícito e escolher cada métrica individualmente.',
    'metrics.publicOn': 'Pública',
    'metrics.publicOff': 'Privada',
    'metrics.age': 'Idade',
    'metrics.weight': 'Peso',
    'metrics.height': 'Altura',
    'metrics.ffm': 'FFM (massa magra)',
    'metrics.bodyFat': 'Gordura corporal',
    'metrics.water': 'Água corporal (TBW)',
    'metrics.bmr': 'BMR (taxa basal)',
    'metrics.bmi': 'IMC',
    'metrics.bmiHint': 'Calculado a partir de peso e altura.',
    'metrics.charts.title': 'Gráficos de progresso',
    'metrics.charts.body': 'Evolução corporal',
    'metrics.charts.bodyQuestion':
      'A massa magra está subindo enquanto a gordura cai?',
    'metrics.charts.bodyNote':
      'Este gráfico combina apenas FFM, gordura e água. Peso e BMR têm leituras próprias.',
    'metrics.charts.weightQuestion': 'Como o peso variou no período?',
    'metrics.charts.sportQuestion': 'Esta métrica está evoluindo no período?',
    'metrics.charts.missing.title': 'Sem gráfico para esta métrica',
    'metrics.charts.missing.body':
      'Escolha uma métrica com histórico registrado para ver a evolução.',

    'category.all': 'Tudo',
    'category.workout': 'Treino',
    'category.running': 'Corrida',
    'category.cycling': 'Ciclismo',
    'category.swimming': 'Natação',
    'category.crossfit': 'CrossFit',
    'category.strength': 'Musculação',
    'category.nutrition': 'Nutrição',
    'category.mindfulness': 'Mente',
    'category.lifestyle': 'Estilo de vida',

    'post.streak': 'sequência de {n} dias',
    'post.hoursAgo': 'há {n}h',
    'post.open': 'Abrir post',
    'post.like': 'Curtir',
    'post.comment': 'Comentar',
    'post.save': 'Salvar',
    'post.share': 'Compartilhar',
    'post.shared': 'Link copiado',
    'post.title': 'Post',
    'post.missing.title': 'Post não encontrado',
    'post.missing.body': 'Esse conteúdo pode ter sido removido pelo autor.',

    'feed.title': 'Comunidade',
    'feed.subtitle': 'Jornadas de saúde de quem você acompanha.',
    'feed.section': 'Publicações recentes',

    'pulse.title': 'Pulse',
    'pulse.create': 'Novo Pulse',
    'pulse.open': 'Abrir Pulse',
    'pulse.mine': 'Meu Pulse',
    'pulse.missing': 'Esse Pulse não está mais disponível.',
    'pulse.backToFeed': 'Voltar para a comunidade',
    'pulse.previous': 'Anterior',
    'pulse.next': 'Próximo',
    'pulse.viewProfile': 'Ver perfil',
    'pulse.empty.title': 'Nenhum Pulse ativo',
    'pulse.empty.body': 'Pulses aparecem aqui enquanto estão ativos.',

    'explore.title': 'Explore',
    'explore.subtitle': 'Descubra pessoas, temas e esportes.',
    'explore.featured': 'Em destaque',
    'explore.topics': 'Temas sugeridos',
    'explore.people': 'Pessoas recomendadas',
    'explore.trending': 'Em alta na comunidade',
    'explore.topicPosts': '{n} publicações',
    'explore.empty.title': 'Nada nessa categoria',
    'explore.empty.body': 'Escolha outra categoria para continuar explorando.',

    'search.title': 'Buscar',
    'search.placeholder': 'Pessoas, temas, esportes ou hashtags',
    'search.clear': 'Limpar busca',
    'search.clearAll': 'Limpar tudo',
    'search.remove': 'Remover',
    'search.recent': 'Buscas recentes',
    'search.suggested': 'Sugestões',
    'search.people': 'Pessoas',
    'search.topics': 'Temas',
    'search.sports': 'Esportes',
    'search.hashtags': 'Hashtags',
    'search.empty.title': 'Nenhum resultado',
    'search.empty.body': 'Não encontramos nada para “{term}”. Tente outro termo.',

    'profile.title': 'Perfil',
    'profile.follow': 'Seguir',
    'profile.following': 'Seguindo',
    'profile.posts': 'Posts',
    'profile.followers': 'Seguidores',
    'profile.followingCount': 'Seguindo',
    'profile.achievements': 'Conquistas públicas',
    'profile.publicMetrics': 'Métricas públicas',
    'profile.privateNote':
      'Métricas de saúde só aparecem aqui quando a própria pessoa escolhe torná-las públicas.',
    'profile.missing.title': 'Perfil não encontrado',
    'profile.missing.body': 'Confira o nome de usuário e tente novamente.',
    'profile.noPosts.title': 'Nenhum post ainda',
    'profile.noPosts.body': 'Quando publicar, os posts aparecem aqui.',

    'comments.title': 'Comentários',
    'comments.count': '{n} no total',
    'comments.seeAll': 'Ver todos os {n} comentários',
    'comments.placeholder': 'Escreva um comentário',
    'comments.send': 'Enviar comentário',
    'comments.empty.title': 'Nenhum comentário',
    'comments.empty.body': 'Seja a primeira pessoa a comentar neste post.',

    'create.pulse.always': 'Sempre disponível',
    'create.media.title': 'Mídia',
    'create.media.capture': 'Capturar',
    'create.media.upload': 'Enviar',
    'create.media.hint': 'No protótipo, escolha uma mídia de exemplo.',
    'create.preview': 'Pré-visualização',
    'create.context.title': 'Contexto',
    'create.context.hint': 'Opcional. Ajuda a comunidade a entender o momento.',
    'create.pulse.label': 'Título',
    'create.pulse.labelHint': 'Treino de manhã',
    'create.pulse.metric': 'Métrica',
    'create.pulse.metricHint': '8 km · 5:20/km',
    'create.publishPulse': 'Publicar Pulse',
    'create.caption.title': 'Legenda',
    'create.caption.hint': 'Conte o que esse momento representa na sua rotina.',
    'create.category.title': 'Categoria',
    'create.activity.title': 'Atividade',
    'create.activity.hint': '12,4 km · 1h02 · 5:00/km',
    'create.location.title': 'Local (opcional)',
    'create.location.hint': 'Parque da Cantareira',
    'create.publishPost': 'Publicar Post',
    'create.needed': 'Escolha uma mídia e escreva a legenda para publicar.',
    'create.gate.reason':
      'O Post completo abre depois de você cuidar do seu dia. O Pulse segue livre.',

    'success.pulse.tag': 'Pulse publicado',
    'success.pulse.title': 'Seu Pulse está ativo.',
    'success.pulse.body':
      'Ele aparece para a comunidade enquanto estiver ativo. Nenhum XP é necessário.',
    'success.post.tag': 'Post publicado',
    'success.post.title': 'Seu post está na comunidade.',
    'success.post.body':
      'Ele leva o contexto da sua jornada: categoria, sequência e conquistas.',
    'success.seeFeed': 'Ver na comunidade',
    'success.backHome': 'Voltar para a Home',

    'notifications.title': 'Notificações',
    'notifications.health': 'Saúde',
    'notifications.healthHint': 'Lembretes de saúde vêm sempre primeiro.',
    'notifications.community': 'Comunidade',
    'notifications.unread': 'Não lida',

    'soon.title': 'Próxima fase',
    'soon.explore':
      'Busca, temas, esportes e pessoas recomendadas entram na fase de Social.',
    'soon.profile':
      'Perfil, métricas corporais (BIA) e métricas esportivas entram na fase de Perfil.',
  },

  'en-US': {
    'nav.home': 'Home',
    'nav.explore': 'Explore',
    'nav.new': 'New',
    'nav.stats': 'Stats',
    'nav.check': 'Check',
    'nav.profile': 'Profile',
    'nav.aria': 'Main navigation',

    'common.xp': 'XP',
    'common.of': 'of',
    'common.day': 'day',
    'common.days': 'days',
    'common.back': 'Back',
    'common.close': 'Close',
    'common.continue': 'Continue',
    'common.notifications': 'Notifications',
    'common.level': 'Level',

    'band.strong': 'Strong range',
    'band.attention': 'Attention range',
    'band.low': 'Low range',

    'home.greeting.morning': 'Good morning',
    'home.greeting.afternoon': 'Good afternoon',
    'home.greeting.evening': 'Good evening',
    'home.lifescore.title': "Today's Life Score",
    'home.lifescore.hint': 'Your wellbeing today on a scale of 0 to 100.',
    'home.message.first': 'Your first day starts now.',
    'home.message.complete': 'Day closed with {total} XP recorded.',
    'home.message.rest': "Today's goal is recovery.",
    'home.message.past50': "You have reached half of today's goal.",
    'home.message.going': '{n} XP left to close your day.',
    'home.message.start': 'Your day has not started counting yet.',
    'home.pending.title': 'Still open today',
    'home.pending.hint': 'Tap to open it in Daily Check.',
    'home.streak.title': 'Streak',
    'home.streak.best': 'No misses since September 9',
    'home.xp.title': 'XP today',
    'home.xp.base': 'of 100 base XP',
    'home.check.title': 'Daily Check',
    'home.check.progress': '{done} of {total} habits completed',
    'home.check.remaining': '{n} XP remaining',
    'home.check.allDone': 'No habits pending',
    'home.milestone.title': 'Next milestone',
    'home.milestone.max': 'All milestones earned',
    'home.check.cta': 'Continue Daily Check',
    'home.check.ctaStart': 'Start Daily Check',
    'home.check.ctaDone': 'View my Daily Check',
    'home.week.title': 'This week',
    'home.week.avg': 'Average {n}',
    'home.community.title': 'Community',
    'home.community.cta': 'See all',
    'home.summary.title': 'Your day',
    'home.summary.lifescore': 'Life Score',
    'home.summary.check': 'Daily Check',
    'home.summary.streak': 'Streak',
    'home.summary.milestone': 'Next milestone',
    'home.summary.open': 'Open Life Score detail',
    'home.pulse.own': 'Your Pulse',
    'home.foryou.title': 'For you',
    'home.foryou.cta': 'Open the feed',
    'home.firstUse.title': 'Start with your day.',
    'home.firstUse.body':
      'Six habits, 100 XP. That is how your Life Score begins.',
    'home.firstUse.cta': 'Do my first check',
    'home.gentle.title': 'Gentle goals for today',
    'home.gentle.body': 'Resting is progress too.',
    'home.gentle.1': "Make progress on today's hydration goal.",
    'home.gentle.2': '10 min walk or stretch',
    'home.gentle.3': '5 min of breathing',
    'home.gentle.4': 'Prioritize an earlier night',

    'check.title': 'Daily Check',
    'check.subtitle': 'Six habits. 100 XP a day.',
    'check.earned': 'XP earned',
    'check.remaining': 'XP remaining',
    'check.completed': 'Completed',
    'check.left': 'Remaining',
    'check.mood.title': 'How are you today?',
    'check.mood.registered': 'Mood recorded',
    'check.bonus.title': 'Photo of the day',
    'check.bonus.body':
      'Optional +10 XP bonus, separate from the 100 XP Daily Check.',
    'check.bonus.cta': 'Add photo',
    'check.bonus.done': '+10 XP bonus received',
    'check.complete.title': 'Day complete',
    'check.complete.body': '100 XP recorded. Your streak reached {n} days.',
    'check.badge.title': 'New badge',
    'check.badge.body': '{days} days of completed Daily Check.',
    'check.unlocked': 'Full Post unlocked',

    'feedback.first': 'Starting is everything.',
    'feedback.half': 'Halfway there.',
    'feedback.fifty': 'Today already counted.',
    'feedback.seventyfive': 'Almost there.',
    'feedback.one': 'Just one left.',

    'habit.hydration.title': 'Hydration',
    'habit.movement.title': 'Movement',
    'habit.movement.goal': 'At least 30 min of activity',
    'habit.mind.title': 'Mind',
    'habit.mind.goal': '10 min of mental clarity',
    'habit.nutrition.title': 'Nutrition',
    'habit.nutrition.goal': "Today's meals and supplements",
    'habit.sleep.title': 'Sleep',
    'habit.sleep.goal': '7h or more of rest',
    'habit.mood.title': 'Mood',
    'habit.mood.goal': 'Record how you feel',

    'mood.drained': 'Drained',
    'mood.tired': 'Tired',
    'mood.neutral': 'Neutral',
    'mood.good': 'Good',
    'mood.focused': 'Focused',

    'level.1': 'Beginner',
    'level.2': 'Apprentice',
    'level.3': 'Warrior',
    'level.4': 'Master',
    'level.5': 'Legend',

    'badge.first': 'First Check',
    'badge.focus': 'Full Focus',
    'badge.week': 'Iron Week',
    'badge.unstoppable': 'Unstoppable',
    'badge.legend': 'Living Legend',

    'stats.title': 'Statistics',
    'stats.subtitle': 'Your consistency over time.',
    'stats.period.today': 'Today',
    'stats.period.week': 'Week',
    'stats.period.month': 'Month',
    'stats.period.year': 'Year',
    'stats.lifescore.today': "Today's Life Score",
    'stats.lifescore.week': 'Average of the last 7 days',
    'stats.lifescore.month': 'Average of the last 30 days',
    'stats.lifescore.year': 'Average of your full recorded history',
    'stats.streak': 'Current streak',
    'stats.avg30': '30-day average',
    'stats.perfect': 'Perfect days',
    'stats.workouts': 'Workouts this week',
    'stats.heatmap.title': 'Consistency · 90 days',
    'stats.heatmap.hint': 'Weeks in columns, starting on Monday.',
    'stats.heatmap.none': 'No record',
    'stats.heatmap.low': 'Low',
    'stats.heatmap.high': 'High',
    'stats.heatmap.perfect': 'Perfect day',
    'stats.heatmap.cell': '{date}: Life Score {score}',
    'stats.heatmap.cellEmpty': '{date}: no record',
    'stats.review.title': 'Weekly review',
    'stats.review.locked': 'Available Sunday, from 6pm.',
    'stats.review.strong': 'Strongest',
    'stats.review.weak': 'Needs attention',
    'stats.review.avg': 'Weekly average',
    'stats.review.tip': 'One practical improvement',
    'stats.review.tipBody':
      'Move bedtime 30 min earlier on the nights before training.',
    'stats.insights.title': 'Mood insights',
    'stats.insights.hint': 'Correlations observed in your records.',
    'stats.goals.title': 'Goals',
    'stats.discipline.title': 'Discipline Built',
    'stats.discipline.body':
      '{n} consecutive days with Life Score 70 or higher. Consistency > Motivation.',
    'stats.category.movement': 'Movement',
    'stats.category.sleep': 'Sleep',

    'create.title': 'Publish',
    'create.subtitle': 'Choose the format of your record.',
    'create.pulse.title': 'Pulse',
    'create.pulse.body': 'A quick record of your moment. Always available.',
    'create.post.title': 'Post',
    'create.post.body': 'A full publication with your journey context.',
    'create.post.locked': 'Requires {gate} XP today',
    'create.post.unlocked': 'Unlocked today',
    'create.gate.progress': '{xp} of {gate} XP today',
    'create.gate.cta': 'Go to Daily Check',

    'common.save': 'Save',
    'common.cancel': 'Cancel',

    'settings.title': 'Settings',
    'settings.group.account': 'Account',
    'settings.group.experience': 'Experience',
    'settings.group.privacy': 'Privacy and security',
    'settings.group.support': 'Support and documents',
    'settings.account': 'Account',
    'settings.language': 'Language',
    'settings.units': 'Units',
    'settings.notifications': 'Notifications',
    'settings.privacy': 'Privacy',
    'settings.security': 'Security',
    'settings.accessibility': 'Accessibility',
    'settings.services': 'Connected services',
    'settings.help': 'Help and support',
    'settings.terms': 'Terms of use',
    'settings.policy': 'Privacy policy',
    'settings.logout': 'Sign out',
    'settings.delete': 'Delete account',
    'settings.deleteHint': 'Permanent action, confirmed in steps.',
    'settings.logout.title': 'Sign out?',
    'settings.logout.body':
      'Your data stays saved. You can sign back in whenever you want.',
    'settings.logout.confirm': 'Sign out now',

    'account.statusActive': 'Active account',
    'account.data': 'Account data',
    'account.email': 'Email',
    'account.birth': 'Date of birth',
    'account.management': 'Account management',
    'account.export': 'Download my data',
    'account.exportHint': 'A file with habits, metrics and posts.',

    'language.subtitle': 'The choice applies to the whole product.',
    'language.note':
      'There are no per-language screens: every string comes from one dictionary.',

    'units.subtitle': 'A single preference for the whole app.',
    'units.metric': 'Metric',
    'units.imperial': 'Imperial',
    'units.affects': 'What changes',
    'units.affects.body': 'Weight, height and body composition',
    'units.affects.sports': 'Distances, pace, splits and loads',
    'units.affects.charts': 'Chart axes and legends',

    'notifPrefs.subtitle': 'Choose what deserves to interrupt your day.',
    'notifPrefs.priority':
      'Health reminders take priority over any social alert.',
    'notifPrefs.group.health': 'Health and wellness',
    'notifPrefs.group.progress': 'Progress',
    'notifPrefs.group.social': 'Social',
    'notifPrefs.group.product': 'Product',
    'notifPrefs.healthNote': 'We recommend keeping this group on.',

    'notifications.today': 'Today',
    'notifications.earlier': 'Earlier',
    'notifications.markAll': 'Mark all as read',
    'notifications.unreadCount': '{n} unread',

    'privacy.subtitle': 'You decide what is public.',
    'privacy.visibility': 'Profile visibility',
    'privacy.health': 'Health data',
    'privacy.healthNote':
      'Body metrics and biomarkers are private by default. No metric is published without your explicit consent, one by one.',
    'privacy.pickMetrics': 'Choose metric by metric.',
    'privacy.dataUse': 'How we use your data',
    'privacy.use1': 'Your records power the Life Score, statistics and insights.',
    'privacy.use2': 'Body metrics and biomarkers are visible only to you unless you choose to make them public.',
    'privacy.use3': 'You can download or delete your data at any time.',
    'privacy.consent': 'Consent history',
    'privacy.consentTitle': 'Make health data public?',
    'privacy.consentBody':
      'This publishes body composition data on your profile. You can turn it off again at any time.',
    'privacy.consentAccept': 'Yes, I consent',
    'privacy.consentKeep': 'Keep it private',

    'security.subtitle': 'Access, devices and activity.',
    'security.access': 'Access',
    'security.password': 'Change password',
    'security.passwordHint': 'Last changed 4 months ago.',
    'security.twoFactor': 'Two-factor authentication',
    'security.twoFactorHint': 'An extra code when signing in on a new device.',
    'security.recovery': 'Account recovery',
    'security.recoveryHint': 'Recovery email and phone.',
    'security.devices': 'Devices',
    'security.sessions': 'Active sessions',
    'security.trusted': 'Trusted devices',
    'security.trustedHint': 'They skip the two-factor code.',
    'security.activity': 'Login activity',

    'sessions.subtitle': 'Where your account is signed in.',
    'sessions.active': 'Active now',
    'sessions.thisDevice': 'This device',
    'sessions.trusted': 'Trusted',
    'sessions.signOut': 'Sign out',
    'sessions.signOutOthers': 'Sign out other devices',
    'sessions.note': 'Ending a session never deletes any data.',

    'a11y.subtitle': 'Adjustments that apply across the app.',
    'a11y.reader': 'Screen readers',
    'a11y.readerBody':
      'Beelyv is built on semantic HTML and descriptive labels, with no separate visual theme.',
    'a11y.point1': 'Every button and toggle announces its label and state.',
    'a11y.point2': 'Charts and the heatmap expose their values as text.',
    'a11y.point3': 'Touch targets are at least 44px.',
    'a11y.note':
      'These preferences adapt the existing design system. No alternative theme is created.',

    'services.subtitle': 'Health and performance integrations.',
    'services.note': 'No integration is active. These connections are in preparation.',
    'services.comingSoon': 'Coming soon',
    'services.futureNote':
      'When a connection becomes available, you authorize access before any sync happens.',

    'help.subtitle': 'Questions, contact and app information.',
    'help.faq': 'Frequently asked questions',
    'help.contactGroup': 'Contact',
    'help.contact': 'Contact support',
    'help.report': 'Report a problem',
    'help.reportHint': 'Bugs, inappropriate content or unexpected behavior.',
    'help.guidelines': 'Community guidelines',
    'help.safety': 'Safety information',
    'help.about': 'About Beelyv',
    'help.version': 'Version',
    'help.aboutBody':
      'An ecosystem of health, mind, habits, performance and community. Self-care first, social second.',
    'help.states': 'App states',
    'help.statesHint': 'Reference for loading, empty, offline and permission states.',

    'export.subtitle': 'A copy of your data, whenever you want.',
    'export.included': 'What the file includes',
    'export.item1': 'Full Daily Check and Life Score history',
    'export.item2': 'Body and sports metrics',
    'export.item3': 'Posts, Pulses and comments',
    'export.item4': 'Account preferences and consents',
    'export.request': 'Request my data',
    'export.again': 'Request again',
    'export.preparing': 'Preparing your file…',
    'export.ready': 'File ready to download',
    'export.readyBody': 'The link is also sent to your registered email.',
    'export.note': 'The file is generated on demand and never shared with third parties.',

    'delete.whatHappens': 'What happens',
    'delete.p1': 'Your profile, posts and Pulses go offline.',
    'delete.p2': 'Habit history, metrics and badges are erased.',
    'delete.p3': 'The action is permanent and cannot be undone.',
    'delete.p4': 'You can download your data before continuing.',
    'delete.alternative': 'Would you rather keep a copy before deciding?',
    'delete.continue': 'Continue',
    'delete.confirmTitle': 'Confirmation',
    'delete.confirmBody':
      'We want to be sure this is your intent. Nothing is deleted at this step.',
    'delete.checkbox':
      'I understand my health data and history will be permanently erased.',
    'delete.passwordTitle': 'Confirm with your password',
    'delete.passwordBody': 'This prevents accidental deletion or deletion by someone else.',
    'delete.passwordHint': 'Your password',
    'delete.finalTitle': 'Final warning',
    'delete.finalBody':
      'On confirmation, deletion starts immediately and the data cannot be recovered.',
    'delete.finalCta': 'Delete my account',
    'delete.keepAccount': 'Keep my account',
    'delete.doneTag': 'Account deleted',
    'delete.doneTitle': 'All done.',
    'delete.doneBody':
      'Your account and data have been removed. Thank you for taking care of your day with Beelyv.',
    'delete.doneCta': 'Back to start',

    'states.title': 'App states',
    'states.subtitle': 'Reference for the reusable global states.',
    'states.group.loading': 'Loading',
    'states.group.content': 'Content',
    'states.group.system': 'System',
    'states.group.access': 'Access and permissions',
    'states.group.feedback': 'Confirmation',

    'state.retry': 'Try again',
    'state.backHome': 'Back to Home',
    'state.permission.cta': 'Open Settings',
    'state.permission.skip': 'Continue without allowing',

    'state.loading.tag': 'Loading',
    'state.loading.title': 'Loading',
    'state.loading.body': 'Fetching your most recent data.',
    'state.skeleton.tag': 'Skeleton',
    'state.skeleton.title': 'Structured loading',
    'state.skeleton.body': 'The layout arrives before the content, with no jumps.',
    'state.empty.tag': 'Empty',
    'state.empty.title': 'Nothing here yet',
    'state.empty.body': 'Once there is content, it shows in this area.',
    'state.success.tag': 'Done',
    'state.success.title': 'All set.',
    'state.success.body': 'Your action was recorded successfully.',
    'state.offline.tag': 'No connection',
    'state.offline.title': 'You are offline.',
    'state.offline.body':
      'No problem: the essentials keep working and sync once the connection is back.',
    'state.offline.p1': 'Checking habits in the Daily Check',
    'state.offline.p2': 'Viewing the Life Score and already-loaded statistics',
    'state.offline.p3': 'Pulse and Post drafts stay saved',
    'state.error.tag': 'Something did not load',
    'state.error.title': 'We could not load this screen.',
    'state.error.body': 'Your data is safe. Please try again in a moment.',
    'state.locked.tag': 'Locked',
    'state.locked.title': 'The full Post is still locked.',
    'state.locked.body':
      'It opens at 50 XP today. Pulse stays available at any time.',
    'state.session.tag': 'Session expired',
    'state.session.title': 'Your session expired.',
    'state.session.body':
      'For your security we ended the session after a period of inactivity. No data was lost.',
    'state.session.cta': 'Sign in again',
    'state.maintenance.tag': 'Maintenance',
    'state.maintenance.title': 'We are under maintenance.',
    'state.maintenance.body': 'An improvement is being applied. Back in a few minutes.',
    'state.update.tag': 'Update available',
    'state.update.title': 'A new version is ready.',
    'state.update.body': 'This update brings fixes and performance improvements.',
    'state.update.cta': 'Update now',
    'state.update.later': 'Later',
    'state.camera.tag': 'Camera blocked',
    'state.camera.title': 'The camera has no permission.',
    'state.camera.body':
      'The camera is used for the Photo of the Day and to create Pulses. You decide whether to allow it.',
    'state.notifications.tag': 'Notifications blocked',
    'state.notifications.title': 'Notifications are turned off.',
    'state.notifications.body':
      'Without them you will not get the Daily Check reminder or the streak warning.',
    'state.location.tag': 'Location blocked',
    'state.location.title': 'Location has no permission.',
    'state.location.body':
      'We use location only to tag a post’s place, when you choose to.',
    'state.photos.tag': 'Photos blocked',
    'state.photos.title': 'The photo library has no permission.',
    'state.photos.body':
      'Library access lets you pick images already saved on your device.',
    'state.no-results.tag': 'No results',
    'state.no-results.title': 'No results found.',
    'state.no-results.body': 'Try another term, sport or hashtag.',
    'state.no-notifications.tag': 'No notifications',
    'state.no-notifications.title': 'No notifications here.',
    'state.no-notifications.body':
      'Health and community alerts appear on this screen.',
    'state.no-posts.tag': 'No posts',
    'state.no-posts.title': 'You have not published anything yet.',
    'state.no-posts.body':
      'Pulse is always available. The full Post opens at 50 XP today.',
    'state.no-metrics.tag': 'No metrics',
    'state.no-metrics.title': 'No metrics recorded.',
    'state.no-metrics.body':
      'Add weight, height and body composition to see your progress.',
    'state.first-use.tag': 'First use',
    'state.first-use.title': 'Start with your day.',
    'state.first-use.body':
      'Six habits, 100 XP. That is how your Life Score begins.',

    'stats.consistency': 'Check consistency',
    'stats.consistencyHint': 'Days recorded in the last 90.',
    'stats.details': 'Detailed analysis',
    'stats.openFull': 'See full',
    'stats.lifescore.open': 'See Life Score in detail',
    'stats.heatmap.question': 'Where are the gaps in the last 90 days?',
    'stats.weekly.title': 'This week’s activity',
    'stats.weekly.question': 'Is the week on the pace you set?',
    'stats.weekly.strongDays': 'Days at 70+',
    'stats.weekly.average': 'Weekly average',

    'lifescore.title': 'Life Score',
    'lifescore.subtitle': 'Your wellbeing today on a scale of 0 to 100.',
    'lifescore.best': 'Best Life Score',
    'lifescore.bestHint': 'Highest value in the period.',
    'lifescore.strongDays': 'Days in the strong range',
    'lifescore.strongHint': 'Life Score 70 or higher.',
    'lifescore.missed': 'Days with no record',
    'lifescore.missedHint': 'No habit checked.',
    'lifescore.bands': 'Ranges',
    'lifescore.note':
      'The score comes only from your 100 base XP. The Photo of the Day bonus is never counted.',

    'heatmap.consistency': 'Consistency',
    'heatmap.consistencyHint': 'Days recorded out of 90.',
    'heatmap.recorded': 'Days recorded',
    'heatmap.recordedHint': 'At least one habit checked.',
    'heatmap.note':
      'Weeks in columns, Monday to Sunday. Gold marks perfect days.',

    'review.subtitle': 'One read per week, without the noise.',
    'review.lockedHint':
      'The review closes the whole week, so it only opens on Sunday evening.',
    'review.avgHint': 'Average of the last 7 Daily Check days.',
    'review.strongHint': 'Most completed category this week.',
    'review.weakHint': 'Category with the most misses this week.',
    'review.tipNote':
      'Suggestion based on your records. Not medical advice.',

    'insights.todayMood': 'Mood recorded today',
    'insights.noMood': 'Not recorded yet',
    'insights.disclaimer':
      'Correlations observed in your own records. Not a diagnosis or medical conclusion.',

    'goals.subtitle': 'Health and performance goals you set.',
    'goals.of': 'of',
    'goals.note':
      'The goals are yours. The app tracks progress and never recommends health values.',

    'metrics.milestones': 'Strength milestones',

    'chart.range.all': 'All',
    'chart.range.3m': '3M',
    'chart.range.6m': '6M',
    'chart.range.1y': '1Y',
    'chart.range.2y': '2Y',

    'profile.edit': 'Edit profile',
    'profile.photo': 'Profile photo',
    'profile.photoHint': 'In the prototype, the photo stays the same.',
    'profile.identity': 'Identity',
    'profile.field.name': 'Display name',
    'profile.field.username': 'Username',
    'profile.field.bio': 'Bio',
    'profile.metricsSection': 'Health and performance',

    'metrics.units': 'Units',
    'metrics.units.metric': 'kg · km',
    'metrics.units.imperial': 'lbs · mi',
    'metrics.values': 'Values',
    'metrics.visible': 'Visible',
    'metrics.hidden': 'Hidden metrics',
    'metrics.restore': 'Restore all',
    'metrics.noRecord': 'No record yet',
    'metrics.openChart': 'open chart',
    'metrics.editBody': 'Edit body metrics',
    'metrics.editHint': 'BMI is calculated and cannot be edited.',
    'metrics.body.title': 'Body metrics',
    'metrics.body.subtitle': 'Body composition and BIA references.',
    'metrics.sports.title': 'Sports metrics',
    'metrics.sports.subtitle': 'Performance by sport, with convertible units.',
    'metrics.sports.note':
      'Tap a metric with a chart to see its progress over time.',
    'metrics.public.title': 'Public metrics',
    'metrics.public.subtitle': 'Choose what appears on your public profile.',
    'metrics.public.note':
      'Body metrics, BIA and biomarkers are private by default. They appear on your public profile only after explicit consent, and only the individual metrics you choose.',
    'metrics.publicOn': 'Public',
    'metrics.publicOff': 'Private',
    'metrics.age': 'Age',
    'metrics.weight': 'Weight',
    'metrics.height': 'Height',
    'metrics.ffm': 'FFM (lean mass)',
    'metrics.bodyFat': 'Body fat',
    'metrics.water': 'Body water (TBW)',
    'metrics.bmr': 'BMR (basal rate)',
    'metrics.bmi': 'BMI',
    'metrics.bmiHint': 'Calculated from weight and height.',
    'metrics.charts.title': 'Progress charts',
    'metrics.charts.body': 'Body evolution',
    'metrics.charts.bodyQuestion': 'Is lean mass rising while body fat falls?',
    'metrics.charts.bodyNote':
      'This chart combines only FFM, body fat and water. Weight and BMR have their own readouts.',
    'metrics.charts.weightQuestion': 'How did weight move over the period?',
    'metrics.charts.sportQuestion': 'Is this metric improving over the period?',
    'metrics.charts.missing.title': 'No chart for this metric',
    'metrics.charts.missing.body':
      'Pick a metric with recorded history to see its progress.',

    'category.all': 'All',
    'category.workout': 'Workout',
    'category.running': 'Running',
    'category.cycling': 'Cycling',
    'category.swimming': 'Swimming',
    'category.crossfit': 'CrossFit',
    'category.strength': 'Strength',
    'category.nutrition': 'Nutrition',
    'category.mindfulness': 'Mindfulness',
    'category.lifestyle': 'Lifestyle',

    'post.streak': '{n}-day streak',
    'post.hoursAgo': '{n}h ago',
    'post.open': 'Open post',
    'post.like': 'Like',
    'post.comment': 'Comment',
    'post.save': 'Save',
    'post.share': 'Share',
    'post.shared': 'Link copied',
    'post.title': 'Post',
    'post.missing.title': 'Post not found',
    'post.missing.body': 'This content may have been removed by its author.',

    'feed.title': 'Community',
    'feed.subtitle': 'Health journeys from people you follow.',
    'feed.section': 'Recent posts',

    'pulse.title': 'Pulse',
    'pulse.create': 'New Pulse',
    'pulse.open': 'Open Pulse',
    'pulse.mine': 'My Pulse',
    'pulse.missing': 'This Pulse is no longer available.',
    'pulse.backToFeed': 'Back to community',
    'pulse.previous': 'Previous',
    'pulse.next': 'Next',
    'pulse.viewProfile': 'View profile',
    'pulse.empty.title': 'No active Pulse',
    'pulse.empty.body': 'Pulses appear here while they are active.',

    'explore.title': 'Explore',
    'explore.subtitle': 'Discover people, topics and sports.',
    'explore.featured': 'Featured',
    'explore.topics': 'Suggested topics',
    'explore.people': 'Recommended people',
    'explore.trending': 'Trending in the community',
    'explore.topicPosts': '{n} posts',
    'explore.empty.title': 'Nothing in this category',
    'explore.empty.body': 'Pick another category to keep exploring.',

    'search.title': 'Search',
    'search.placeholder': 'People, topics, sports or hashtags',
    'search.clear': 'Clear search',
    'search.clearAll': 'Clear all',
    'search.remove': 'Remove',
    'search.recent': 'Recent searches',
    'search.suggested': 'Suggestions',
    'search.people': 'People',
    'search.topics': 'Topics',
    'search.sports': 'Sports',
    'search.hashtags': 'Hashtags',
    'search.empty.title': 'No results',
    'search.empty.body': 'We found nothing for “{term}”. Try another term.',

    'profile.title': 'Profile',
    'profile.follow': 'Follow',
    'profile.following': 'Following',
    'profile.posts': 'Posts',
    'profile.followers': 'Followers',
    'profile.followingCount': 'Following',
    'profile.achievements': 'Public achievements',
    'profile.publicMetrics': 'Public metrics',
    'profile.privateNote':
      'Health metrics appear here only when the person chooses to make them public.',
    'profile.missing.title': 'Profile not found',
    'profile.missing.body': 'Check the username and try again.',
    'profile.noPosts.title': 'No posts yet',
    'profile.noPosts.body': 'Once published, posts show up here.',

    'comments.title': 'Comments',
    'comments.count': '{n} in total',
    'comments.seeAll': 'See all {n} comments',
    'comments.placeholder': 'Write a comment',
    'comments.send': 'Send comment',
    'comments.empty.title': 'No comments',
    'comments.empty.body': 'Be the first to comment on this post.',

    'create.pulse.always': 'Always available',
    'create.media.title': 'Media',
    'create.media.capture': 'Capture',
    'create.media.upload': 'Upload',
    'create.media.hint': 'In the prototype, pick a sample media.',
    'create.preview': 'Preview',
    'create.context.title': 'Context',
    'create.context.hint': 'Optional. Helps the community read the moment.',
    'create.pulse.label': 'Title',
    'create.pulse.labelHint': 'Morning session',
    'create.pulse.metric': 'Metric',
    'create.pulse.metricHint': '8 km · 5:20/km',
    'create.publishPulse': 'Publish Pulse',
    'create.caption.title': 'Caption',
    'create.caption.hint': 'Tell what this moment means in your routine.',
    'create.category.title': 'Category',
    'create.activity.title': 'Activity',
    'create.activity.hint': '12.4 km · 1h02 · 5:00/km',
    'create.location.title': 'Location (optional)',
    'create.location.hint': 'Cantareira Park',
    'create.publishPost': 'Publish Post',
    'create.needed': 'Pick a media and write a caption to publish.',
    'create.gate.reason':
      'The full Post opens after you take care of your day. Pulse stays free.',

    'success.pulse.tag': 'Pulse published',
    'success.pulse.title': 'Your Pulse is live.',
    'success.pulse.body':
      'It shows to the community while active. No XP required.',
    'success.post.tag': 'Post published',
    'success.post.title': 'Your post is in the community.',
    'success.post.body':
      'It carries your journey context: category, streak and achievements.',
    'success.seeFeed': 'See in community',
    'success.backHome': 'Back to Home',

    'notifications.title': 'Notifications',
    'notifications.health': 'Health',
    'notifications.healthHint': 'Health reminders always come first.',
    'notifications.community': 'Community',
    'notifications.unread': 'Unread',

    'soon.title': 'Next phase',
    'soon.explore':
      'Search, topics, sports and recommended people arrive in the Social phase.',
    'soon.profile':
      'Profile, body metrics (BIA) and sports metrics arrive in the Profile phase.',
  },
}
